<template>
  <div class="filter-item">
    <label>{{label}}</label>
    <span class="float-right text-muted" v-if="information && information.length" v-b-tooltip.hover.left="information">
      <i class="fal fa-info-circle"></i>
    </span>
    <b-overlay :show="loadingData" spinner-small>
    <b-form-group class="mb-0" style="position: relative">
      <b-form-input
        type="text"
        class="shadow-none"
        :placeholder="!searchValue ? `-- Seleccione un ${label.toLowerCase()} --`: searchValue"
        v-model.trim="searchValue"
        :maxlength="255"
        autocomplete="off"
        :disabled="disabled"
        @click="showSelector(true)"
        @focus="showSelector(true)"
        @blur="showSelector(false)"
        >
      </b-form-input>
      <div class="dropdown-input-selection-list" v-if="selectionActive" style="top: 40px; z-indez: 5">
        <table class="table" style="z-index: inherit;" v-if="values.length">
          <tbody>
            <tr v-for="it in values" :key="it.id" @click="selectValue(it, true)" v-show="isMatchValue(it)">
              <td>{{ it.name }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          No se cuenta con registros para seleccionar
        </div>
      </div>
    </b-form-group>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { BasicEntity } from '@/types/Catalogs'

@Component({
  name: 'InputSelectorFilter'
})
export default class InputSelectorFilter extends Vue {
  @Prop({ required: false, default: 'Campo' })
  label: string

  @Prop({ required: false, default: false })
  loadingData: boolean

  @Prop({ required: false, default: false })
  disabled: boolean

  @Prop({ required: true })
  defaultValue: BasicEntity

  @Prop({ required: true })
  values: BasicEntity[]

  @Prop({ required: false })
  information: string

  searchValue: string = ''
  selectionActive: boolean = false
  valueSelected: BasicEntity = new BasicEntity(-1, '')
  valueIdSelected: number = -1
  valueSelectedBackup: BasicEntity = new BasicEntity(-1, '')

  created () {
    this.selectDefaultValue()
  }

  @Watch('defaultValue')
  cambiandoDefault () {
    // When default value does not have a valid id
    if (this.defaultValue.id <= 0) {
      this.selectDefaultValue()
    }
  }

  /**
   * Active selectionActive flag to display the dropdown value list
   * and updates the searchValue and valueSelected values when the dropdown is close
   * @param isOpen flag
   */
  showSelector (isOpen: boolean) {
    if (isOpen) {
      this.searchValue = ''
      this.valueSelected = new BasicEntity(-1, '')
      this.selectionActive = true
    } else {
      setTimeout(() => {
        this.selectionActive = false
        if (this.valueSelectedBackup.name && this.valueSelectedBackup.id !== this.valueSelected.id) {
          this.searchValue = this.valueSelectedBackup.name
          this.valueSelected = this.valueSelectedBackup
        }
      }, 200)
    }
  }

  /**
   * Validates if a value name matches with the current 'searchValue'
   * @param value entity to check by its name
   */
  isMatchValue (value: BasicEntity) {
    if (!this.searchValue) return true
    const regexSearch = new RegExp(this.searchValue, 'i')
    return regexSearch.test(value.name)
  }

  /**
   * Updates values variables based on 'valueSelected'
   * @param value selected
   * @param emitValut when must emit the value has been changed
   */
  selectValue (value: BasicEntity, emitValue: boolean) {
    this.valueSelected = value
    this.valueSelectedBackup = value
    this.searchValue = value.name
    this.valueIdSelected = value.id
    if (emitValue) {
      this.updateValue()
    }
  }

  /**
   * Sets a default value as selected
   */
  selectDefaultValue () {
    this.valueIdSelected = this.defaultValue.id
    const defaultValueSelected = this.values.find(it => it.id === this.defaultValue.id) || this.defaultValue
    if (defaultValueSelected) this.selectValue(defaultValueSelected, false)
  }

  /** Emits that the value selected has been changed */
  updateValue () {
    this.$emit('update-value', this.valueSelected)
  }
}

</script>

<style scoped>
.dropdown-input-selection-list > .table > tr {
  font-size: 1.2rem;
}
</style>
